export class ApiError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ApiError';
  }
}

export class NetworkError extends Error {
  constructor(message = 'No internet connection. Please check your network.') {
    super(message);
    this.name = 'NetworkError';
  }
}

export class RequestTimeoutError extends Error {
  constructor(message = 'Request timed out. Please try again.') {
    super(message);
    this.name = 'RequestTimeoutError';
  }
}

export class MaintenanceError extends Error {
  constructor(message = 'Server is under maintenance. Please try again later.') {
    super(message);
    this.name = 'MaintenanceError';
  }
}

export function errorMessage(error: unknown): string {
  if (error instanceof ApiError) return error.message;
  if (error instanceof NetworkError) return error.message;
  if (error instanceof RequestTimeoutError) return error.message;
  if (error instanceof MaintenanceError) return error.message;
  if (error instanceof Error) return error.message;
  return 'Something went wrong';
}
